export function enrichRewardSteps(
	rewardSteps,
	{ userLightningAddress, userReferrals, storeAllLink, storeAllConversion }
) {
	return rewardSteps.map((step) => {
		let claimable = false;

		switch (step.stepKey) {
			case 'add_wallet':
				claimable = !!userLightningAddress;
				break;
			case 'click_store':
				claimable = storeAllLink?.length > 0;
				break;
			case 'first_purchase':
				claimable = storeAllConversion?.length > 0;
				break;
			case 'refer_link':
				claimable = userReferrals > 0;
				break;
			default:
				claimable = false;
		}

		return {
			...step,
			claimable: !step.completed && claimable,
		};
	});
}
